import { useMutation } from '@tanstack/react-query';
import { viewEducationFunction } from './viewEducationQueryFunction';

export const useViewEducationQueryOptions = () => {
  return useMutation({
    mutationKey: ['viewEducation'],
    mutationFn: (data: { id: number }) => viewEducationFunction(data),
  });
};
